export default function SvgReferto({ fill }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25.237" height="23.581" viewBox="0 0 25.237 23.581">
    <path id="Tracciato_5489" data-name="Tracciato 5489" d="M28.944,9.2a7.765,7.765,0,0,0-10.323-.533A7.746,7.746,0,0,0,7.008,18.511h3.759l3.9-6.76,2.553,7.742,2.861-5.077,2.412,4.124h2.3a.842.842,0,1,1,0,1.683H21.539L20.108,17.81,16.8,23.617l-2.581-7.77-2.5,4.348H8.3L18.621,30.517,29,20.138A7.746,7.746,0,0,0,28.944,9.2Z" transform="translate(-5.997 -6.936)" fill="#fff"/>
  </svg>
  );
}
